//
// GENERATED by KVision
//
package pl.finn.forms.service

import org.w3c.fetch.RequestInit
import io.kvision.remote.KVRemoteAgent
import pl.finn.forms.model.Attachment
import pl.finn.forms.model.DocumentTreeNode
import pl.finn.forms.model.FormStructureModel

actual class DocumentService(requestFilter: (RequestInit.() -> Unit)? = null) : IDocumentService, KVRemoteAgent<DocumentService>(DocumentServiceManager, requestFilter) {
    override suspend fun createNewForm(token: String) = call(IDocumentService::createNewForm, token)
    override suspend fun editForm(token: String) = call(IDocumentService::editForm, token)
    override suspend fun saveForm(elements: DocumentTreeNode?, attachments: List<Attachment>, validateResult: String?, token: String) = call(IDocumentService::saveForm, elements, attachments, validateResult, token)
    override suspend fun validateForm(elements: DocumentTreeNode?, attachments: List<Attachment>, token: String) = call(IDocumentService::validateForm, elements, attachments, token)
    override suspend fun previewForm(elements: DocumentTreeNode?, attachments: List<Attachment>, token: String) = call(IDocumentService::previewForm, elements, attachments, token)
}
